import axios from 'axios'
import { BASE_URL } from './base-url'

var base = BASE_URL;

export default class LoginService {

    postLogin(data, token) {
        return new Promise((done, reject) => {
            var instance = {
                baseURL: base + '/api/logins',
                method: 'post',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + token
                },
                data: data
            };
            axios(instance).then((response) => {
                done(response.data);
            }).catch((error) => {
                reject(error);
            })
        });
    }

}